import React, { useState } from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import PhotoLibraryOutlinedIcon from '@mui/icons-material/PhotoLibraryOutlined';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Link } from 'react-router-dom';
import SalonManagementPanel from '../components/SalonManagementPanel';
import SalonBrandingDialog from '../components/SalonBrandingDialog';
import PageMenuButton from '../components/PageMenuButton';
import { useAuth } from '../auth/AuthContext';
import { canAccessBackoffice, canManageSalonBranding } from '../utils/auth';
import './Salao.css';

const Salao = () => {
  const auth = useAuth();
  const [brandingOpen, setBrandingOpen] = useState(false);
  const [headerActionsContainer, setHeaderActionsContainer] = useState(null);
  return (
    <Box className="salao-page" sx={{ p: { xs: 1.5, md: 2 }, minHeight: '100vh', bgcolor: '#f8fafc' }}>
    <Stack direction={{ xs: 'column', lg: 'row' }} alignItems={{ lg: 'center' }} justifyContent="space-between" gap={1.5} sx={{ mb: 1.5 }}>
      <Box>
        <Stack direction="row" alignItems="center" spacing={0.5}>
          <PageMenuButton />
          <Typography variant="h4" sx={{ fontWeight: 900 }}>Salão</Typography>
        </Stack>
        <Typography color="text.secondary">Mesas, comandas, consumo e conferência de pagamentos.</Typography>
      </Box>
      <Stack
        ref={setHeaderActionsContainer}
        direction={{ xs: 'column', sm: 'row' }}
        gap={1}
        flexWrap="wrap"
        sx={{ width: { xs: '100%', lg: 'auto' }, '& .MuiButton-root': { minHeight: 42 } }}
      >
        {canManageSalonBranding(auth.user) ? (
          <Button
            onClick={() => setBrandingOpen(true)}
            startIcon={<PhotoLibraryOutlinedIcon />}
            variant="outlined"
          >
            Personalizar cardápio QR
          </Button>
        ) : null}
        {canAccessBackoffice(auth.user) ? (
          <Button component={Link} to="/cardapio" startIcon={<Inventory2OutlinedIcon />} variant="outlined">
            Ir para Cardápio
          </Button>
        ) : null}
        <Button onClick={() => window.dispatchEvent(new CustomEvent('brutos:salon-refresh'))} startIcon={<RefreshIcon />} variant="contained">
          Atualizar mesas
        </Button>
      </Stack>
    </Stack>
    <SalonManagementPanel managementActionContainer={headerActionsContainer} />
    {brandingOpen && canManageSalonBranding(auth.user) ? (
      <SalonBrandingDialog open={brandingOpen} onClose={() => setBrandingOpen(false)} />
    ) : null}
    </Box>
  );
};

export default Salao;
